module.exports = __webpack_public_path__ + "static/img/a075.f335d5d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a075.jpg
// module id = P3N2
// module chunks = 0